var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tutor-trans"},[_c('img',{ref:"liqtrans",staticStyle:{"display":"none"},attrs:{"src":require("assets/ui/liq2trans.png")}}),_c('canvas',{ref:"trans",staticClass:"mode-trans"})])}
var staticRenderFns = []

export { render, staticRenderFns }